import { Storybook } from "@tento-ui/ui/storybook";
import { NaiveDate } from "@tento-chrono";
import { WeatherLocations } from "@tento-lona";
import { WeatherCardPreview } from "./weather-preview-card";

/** The examples' location, chosen explicitly (a card with none shows nothing). */
const SAN_FRANCISCO = WeatherLocations.FALLBACK.all[0].id;

export class WeatherPreviewCardStoryBook extends Storybook.Default {
  title(): string {
    return "Weather Preview Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Today's Weather",
        render: () => {
          return WeatherCardPreview.make()
            .assignStyles({
              width: "100%",
              maxWidth: "400px",
              height: "400px",
            })
            .bind({ date: NaiveDate.today(), lid: SAN_FRANCISCO });
        },
      },
      {
        title: "Tomorrow's Weather",
        render: () => {
          return WeatherCardPreview.make()
            .assignStyles({
              width: "100%",
              maxWidth: "400px",
              height: "400px",
            })
            .bind({ date: NaiveDate.today().addDays(1), lid: SAN_FRANCISCO });
        },
      },
      {
        title: "Large Card",
        render: () => {
          return WeatherCardPreview.make()
            .assignStyles({
              width: "100%",
              maxWidth: "600px",
              height: "400px",
            })
            .bind({ date: NaiveDate.today(), lid: SAN_FRANCISCO });
        },
      },
      {
        title: "Compact Card",
        render: () => {
          return WeatherCardPreview.make()
            .assignStyles({
              width: "100%",
              maxWidth: "300px",
              height: "400px",
            })
            .bind({ date: NaiveDate.today(), lid: SAN_FRANCISCO });
        },
      },
    ];
  }
}
